import dayjs from 'dayjs';

export const getChartOptions = chart => {
  return {
    chart: {
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
    },
    title: {
      text: '',
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: 40,
      },
    },
    colors: [chart.color],
    xaxis: {
      categories: chart.categories?.map(item => (item.length > 20 ? `${item.slice(0, 20)}...` : item)),
      labels: {
        formatter: val => {
          if (chart.isDatetime) {
            return dayjs(val).format('MMM D');
          }
          return val;
        },
        style: {
          fontFamily: 'Manrope',
          fontWeight: 600,
        },
      },
      tooltip: {
        enabled: false,
      },
    },
    yaxis: {
      title: {
        text: undefined,
      },
    },
    tooltip: {
      style: {
        fontFamily: 'Manrope',
      },
      custom: ({ series, dataPointIndex }) => {
        const value = series.reduce((tt, item) => +tt + +item[dataPointIndex], 0);
        return `
          <div class="chart-tooltip">
            <div class="date">${chart.categories[dataPointIndex]}</div>
            <div class="level">${value}</div>
          </div>
        `;
      },
    },
    fill: {
      opacity: 1,
    },
    dataLabels: {
      enabled: true,
    },
    legend: {
      show: false,
    },
  };
};
